import { formatDate, getSelectioAxios, isEmpty } from '@/main';

export default class PortfolioService {

  deletePortfolio(portfolioId, params) {
    return getSelectioAxios()
      .post(`/portfolios/${portfolioId}/delete`, params)
      .then(response => {
        return response.data;
      });
  }

  getPortfolioById(portfolioId) {
    return getSelectioAxios()
      .get(`/portfolios/${portfolioId}`)
      .then(response => response.data);
  }

  updateStatusAndGroupPortfolio(portfolio) {
    const params = {
      idPortfolio: portfolio.id,
      status: portfolio.status,
      groupCode: portfolio.groupCode,
    };
    return getSelectioAxios()
      .patch('/portfolios/' + portfolio.id, params)
      .then(response => response.data);
  }

  portfolioUpdated(username, companyCode, idPortfolio) {
    return getSelectioAxios()
      .get('/portfolios/' + idPortfolio + '/username/' + username + '/company-code/' + companyCode)
      .then(response => response.data);
  }

  getCountActiveCustomerPortfolios(companyId, agencyCode) {
    return getSelectioAxios()
      .get('/portfolios/companies/' + companyId + '/agency/' + (isEmpty(agencyCode) ? 0 : agencyCode) + '/customer/active/count')
      .then(response => {
        return response.data;
      });
  }

  getCountActiveProspectPortfolios(companyId, agencyCode) {
    return getSelectioAxios()
      .get('/portfolios/companies/' + companyId + '/agency/' + (isEmpty(agencyCode) ? 0 : agencyCode) + '/prospect/active/count')
      .then(response => {
        return response.data;
      });
  }

  getPolicyNumbersByCustomer(user, customerCode) {
    return getSelectioAxios().get(`/portfolios/user/${user.username}/customers/${customerCode}/policy-numbers`)
      .then(response => response.data);
  }

  resetPortfolio(portfolio, mail) {
    const buyerList = [];
    const buyerFiscalDataList = [];
    const buyerCustomDataList = [];
    const portfolioInput = this.preparePortfolioInput(portfolio, buyerList, buyerFiscalDataList, buyerCustomDataList);
    const variables = {
      'portfolio': portfolioInput,
      'buyerList': buyerList,
      'buyerFiscalDataList': buyerFiscalDataList,
      'buyerCustomDataList': buyerCustomDataList,
      'email': mail,
    };
    console.log(`ENDPOINT resetPortfolio /portfolios/reset`, JSON.parse(JSON.stringify(variables)));
    return getSelectioAxios().post('/portfolios/reset', variables)
      .then(response => response.data);
  }

  savePortfolio(portfolio, mail) {
    const buyerList = [];
    const buyerFiscalDataList = [];
    const buyerCustomDataList = [];
    const portfolioInput = this.preparePortfolioInput(portfolio, buyerList, buyerFiscalDataList, buyerCustomDataList);
    const variables = {
      resetCustomData: portfolio.resetCustomData,
      'portfolio': portfolioInput,
      'buyerList': buyerList,
      'buyerFiscalDataList': buyerFiscalDataList,
      'buyerCustomDataList': buyerCustomDataList,
      'email': mail,
    };
    console.log(`ENDPOINT resetPortfolio /portfolios/`, JSON.parse(JSON.stringify(variables)));
    if (portfolioInput.id > 0) {
      return getSelectioAxios().put('/portfolios/', variables)
        .then(response => response.data);
    } else {
      return getSelectioAxios().post('/portfolios/', variables)
        .then(response => response.data);
    }
  }

  getTemplateCodes(companyId) {
    return getSelectioAxios().get('/portfolios/companies/' + companyId + '/templates')
      .then(result => result.data);
  }

  getFiscalIdentifiersTypes(country) {
    return getSelectioAxios().get('/uber/commons/fiscal-identifier-types/country/' + country)
      .then(result => result.data);
  }

  getPortfolioFullStatisticsByIds(portfolioIds) {
    return getSelectioAxios()
      .post('/portfolios/full-statistics-by-ids', {
        portfolioIds: portfolioIds
      })
      .then(response => response.data);
  }

  preparePortfolioInput(portfolio, buyerList, buyerFiscalDataList, buyerCustomDataList) {
    const portfolioInput = JSON.parse(JSON.stringify(portfolio));
    portfolioInput.customer = portfolioInput.customer != null ? portfolioInput.customer.code : null;
    portfolioInput.startingDate = portfolioInput.startingDate != null ? formatDate(portfolioInput.startingDate, 'yyyy-mm-dd') : null;
    portfolioInput.endingDate = portfolioInput.endingDate != null ? formatDate(portfolioInput.endingDate, 'yyyy-mm-dd') : null;
    portfolioInput.contractExpiration = portfolioInput.contractExpiration != null ? formatDate(portfolioInput.contractExpiration, 'yyyy-mm-dd') : null;
    if (portfolio.buyers != null) {
      portfolioInput.buyers.forEach(buyer => {
        buyer.portfolio = { id: portfolioInput.id };
        buyerList.push(buyer);

        if (buyer.buyerFiscalData != null) {
          buyer.buyerFiscalData
            // .filter(fiscalData => (fiscalData.updated || fiscalData.id < 0) && !isEmpty(fiscalData.value))
            .filter(fiscalData => !(isEmpty(fiscalData.value) && fiscalData.id < 0)) // esclude nuovi vuoti
            .forEach(fiscalData => {
              buyerFiscalDataList.push({
                id: fiscalData.id,
                value: fiscalData.value,
                buyer: { id: buyer.id, customerRef: buyer.customerRef },
                fiscalIdentifier: { id: fiscalData.fiscalIdentifier.id },
              });
            });
        }

        if (buyer.buyerCustomData != null) {
          buyer.buyerCustomData
            // .filter(customData => customData.updated || customData.delete || customData.id < 0)
            // .filter(customData => !isEmpty(customData.value))
            .filter(customData => !isEmpty(customData.value) || customData.updated || customData.delete || customData.id < 0)
            .filter(customData => !(isEmpty(customData.value) && customData.id < 0)) // esclude nuovi vuoti
            .forEach(customdata => {
              customdata.buyer = { id: buyer.id };
              customdata.idBuyer = buyer.id;
              delete customdata.updated;
              delete customdata.newId;
              buyerCustomDataList.push(customdata);
            });
        }

        delete buyer.buyerFiscalData;
        delete buyer.buyerCustomData;
        delete buyer.mainFiscalId;
        delete buyer.mainFiscalRef;
        delete buyer.analysisResult;
        delete buyer.impName;
        delete buyer.impCountry;
        delete buyer.impCustomerFiscalRef;
        delete buyer.impCustomerName;
        delete buyer.impExposure;
        delete buyer.impTurnover;
        delete buyer.impOverdue;
        delete buyer.impError;
        delete buyer.impCustomerRef;
        delete buyer.active;
        delete buyer.newId;
        delete buyer.count;
        delete buyer.a_exposure;
        delete buyer.currentAnalysis;
        delete buyer.easynumberBuyer;
        delete buyer.businessName;
        delete buyer.totaleAttivo;
        delete buyer.patrimonioNetto;
        delete buyer.ricavi;
        delete buyer.workingCapital;
        delete buyer.numeroAddetti;
        delete buyer.deltaRiskClass;
        delete buyer.riskClass;
        delete buyer.comparedRiskLevel;
        delete buyer.riskLevel;
        delete buyer.riskLevelDescription;
        delete buyer.negativeEvent;
        delete buyer.geographicArea;
        delete buyer.equityCluster;
        delete buyer.economicTrend;
        delete buyer.economicActivity;
        delete buyer.claimSeverity;
        delete buyer.deleted;
        delete buyer.created;
        delete buyer.updated;
      });
    }
    delete portfolioInput.reset;
    delete portfolioInput.groupCode;
    delete portfolioInput.editing;
    delete portfolioInput.startingDateFormatted;
    delete portfolioInput.endingDateFormatted;
    delete portfolioInput.reload;
    delete portfolioInput.newId;
    delete portfolioInput.portfolioType;
    delete portfolioInput.buyers;
    delete portfolioInput.forceContractRenewal;
    delete portfolioInput.buyersCount;
    delete portfolioInput.excludedColumns;
    delete portfolioInput.selectioInsured;
    delete portfolioInput.remainingDaysToExpire;
    delete portfolioInput.code;
    delete portfolioInput.iconContract;
    delete portfolioInput.customer;
    delete portfolioInput.selectioInsuredAvailable;
    delete portfolioInput.created;
    delete portfolioInput.lastUpdatePortfolio;
    delete portfolioInput.sftpExport;
    return portfolioInput;
  }
}
